export { default as SingleCard } from './single-card/single-card';
